<template>
    <div class="feedback">
        <div class="feedback_list">
            <cell title="紧急程度">
                <ul class="ul_view">
                    <li class="tab" v-for="(t,index) in tab" :key="index"
                    :class="{tabColor:index == tabNum1 && index==0,tabColor_orange:index == tabNum1 &&index == 1,tabColor_red:index == tabNum1 && index == 2}"
                    @click="tabClick1(index)">{{t}}</li>
                </ul>
            </cell>
            <!-- <cell title="反馈结果">
                <ul class="ul_view">
                    <li class="tab" v-for="(t,index) in tab1" :key="index" :class="{tabColor:index == tabNum2}" @click="tabClick2(index)">{{t}}</li>
                </ul>
            </cell> -->
            <cell title="工单分类">
                <ul class="ul_view">
                    <li class="tab" v-for="(t,index) in tab2" :key="index" :class="{tabColor:index == tabNum3}" @click="tabClick3(index)">{{t}}</li>
                </ul>
            </cell>
            <cell v-for="(item,index) in list1" :key="index" :title="item.title"
                    is-link :value="item.value"
                    value-class=money
                    @click="handleSelectItme(index)"></cell>
            <!-- <cell title="赔偿金额" value="请输入赔偿金额" class="list_price">
                <input class="money" v-model="money" maxlength="10"/>
                <span style="position:relative;z-index:100">元</span>
            </cell> -->
            <!-- <div class="sell_price">
                <div class="sell_item">
                    <span class="sell_text">赔偿金额</span>
                    <div class="sell_right">
                        <input class="money" v-model.trim="money" maxlength="10"/>
                        <span>元</span>
                    </div>
                </div>
                
            </div> -->
            <cell-group>
                <van-field
                    rows="2"
                    autosize
                    label="处置反馈"
                    type="textarea"
                    maxlength="200"
                    placeholder="请输入当前处置进度"
                    class="list_text"
                    v-model="feedbackContent"
                />
            </cell-group>
            <!-- <textArea placeholder="请输入反馈结果"  v-model="feedbackContent"></textArea> -->
            <div class="uploadBox">
               <upload :imgUrl="imgUrl"></upload>
            </div>
            <div class="guide_buttom">
                <van-button class="guide_btn" @click="submitFeedback">提交</van-button>
                <div class="guide_save_btn" @click="saveManuscript">保存草稿</div>
            </div>
            <van-action-sheet v-model="isshowBox1" :actions="actions" @select="onSelect" title="请选择"/>
            <van-action-sheet v-model="isshowBox2" :actions="actions1" @select="onSelect" title="请选择"/>
            <van-action-sheet v-model="isshowBox3" :actions="actions2" @select="onSelect" title="请选择"/>
            <van-action-sheet v-model="isshowBox4" :actions="actions3" @select="onSelect" title="请选择"/>
        </div>
        <!-- <van-popup v-model="showNav" class="window_box">
            <div class="window_title">
                提交成功
            </div>
            <div class="window_nav">
                是否立即完善信息!
            </div>
            <div class="window_btn">
                <div class="window_btn_item" @click="bandleBtn(1)">否</div>
                <div class="window_btn_item" @click="bandleBtn(2)">是</div>
            </div>
        </van-popup> -->

    </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import util from '@/utils/common'
    import upload from '@/components/uploadCopy'
    export default {
        components: {
            upload
        },
        data () {
            return {
                showNav: false,
                classify: '',
                objectlist: '',
                one: '',
                two: '',
                resultType: 3, // 反馈结果
                urgencyDegree: 7, // 紧急程度
                category: 5, // 工单分类
                list: [
                    { title: '紧急程度' },
                    { title: '反馈结果' },
                    { title: '工单分类' }
                ],
                list1: [
                    { title: '投诉分类', value: '请选择' },
                    { title: '被投诉对象', value: '请选择' },
                    { title: '投诉问题', value: '请选择' },
                    { title: '具体情形', value: '请选择' }
                ],
                tab: ['一般', '较重', '严重'],
                tab1: ['调解成功', '调解失败'],
                tab2: ['投诉', '建议'],
                tabNum1: 0,
                tabNum2: 0,
                tabNum3: 0,
                pid: 0,
                isshowBox1: false,
                isshowBox2: false,
                isshowBox3: false,
                isshowBox4: false,
                actions: [], // 投诉分类选项
                actions1: [], // 被投诉对象选项
                actions2: [], // 投诉问题选项
                actions3: [], // 具体情形选项
                selectIndex: 0,
                itemList: util.getJsonLocal('item'),
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                feedbackContent: '',
                money: null,
                // isShowBtn: false,
                flag: false,
                imgUrl: [] // 上传的图片

            }
        },

        created () {
            this.getSaveDetail();
            this.getType();
            this.getIntelligentClassify();
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val;
            })
        },
        methods: {
            afterRead (file) {
                // 此时可以自行将文件上传至服务器
                console.log(file);
            },
            // 紧急程度
            tabClick1 (index) {
                this.tabNum1 = index;
                switch (index) {
                case 0:
                    this.urgencyDegree = 7
                    break;
                case 1:
                    this.urgencyDegree = 8
                    break;
                case 2:
                    this.urgencyDegree = 9
                    break;
                default:
                    break;
                }
            },
            // 反馈结果
            tabClick2 (index) {
                this.tabNum2 = index;
                switch (index) {
                case 0:
                    this.resultType = 3;
                    break;
                case 1:
                    this.resultType = 4;
                    break;
                default:
                    break;
                }
            },
            // 工单分类
            tabClick3 (index) {
                this.tabNum3 = index;
                switch (index) {
                case 0:
                    this.category = 5;
                    break;
                case 1:
                    this.category = 6;
                    break;
                default:
                    break;
                }
            },
            getType () { // 获取投诉分类
                let params={
                  data:{
                    'pid':'0'
                  }
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            let arr=[];
                            res.data.list.map(item=>{
                              arr.push({'name':item.label,'id':item.value})
                            })
                            this.actions = arr;
                        }
                    }
                })
            },
            getType1 (pid) { // 获取分类
                let params={
                  data:{
                    'pid': pid? pid : this.pid
                  }
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            let arr=[];
                            res.data.list.map(item=>{
                                arr.push({'name':item.label,'id':item.value})
                            })
                            this.actions1 = arr;
                        }
                        
                    }
                })
            },
            getType2 (pid) { // 获取分类
                let params={
                  data:{
                    'pid': pid? pid : this.pid
                  }
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            let arr=[];
                            res.data.list.map(item=>{
                                arr.push({'name':item.label,'id':item.value})
                            })
                            this.actions2 = arr;
                        }
                    }
                })
            },
            getType3 () { // 获取具体情形选项
                let params={
                    data:{'pid': this.pid}
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            let arr=[];
                             res.data.list.map(item=>{
                                arr.push({'name':item.label,'id':item.value})
                            })
                            this.actions3 = arr;
                            
                        }
                    }
                })
            },
            onSelect (item) {
                if (this.selectIndex === 0) {
                    this.pid = item.id;
                    this.list1[0].value = item.name;
                    this.isshowBox1 = false;
                    this.actions1 = [];
                    this.actions2 = [];
                    this.actions3 = [];
                    this.list1[1].value = '请选择';
                    this.list1[2].value = '请选择';
                    this.list1[3].value = '请选择';
                    this.classify = item.id;
                    this.getType1();
                } else if (this.selectIndex === 1) {
                    this.list1[1].value = item.name;
                    this.pid = item.id;
                    this.isshowBox2 = false;
                    this.actions2 = [];
                    this.actions3 = [];
                    this.list1[2].value = '请选择';
                    this.list1[3].value = '请选择';
                    this.objectlist = item.id;
                    this.getType2();
                } else if (this.selectIndex === 2) {
                    this.list1[2].value = item.name;
                    this.pid = item.id;
                    this.isshowBox3 = false;
                    this.actions3 = [];
                    this.list1[3].value = '请选择';
                    this.one = item.id;
                    this.getType3();
                } else if (this.selectIndex === 3) {
                    this.list1[3].value = item.name;
                    this.isshowBox4 = false;
                    this.two = item.id
                }
            },
            handleSelectItme (index) {
                switch (index) {
                case 0:
                    this.selectIndex = index;
                    this.isshowBox1 = true;
                    break;
                case 1:
                    this.selectIndex = index;
                    if (this.list1[0].value === '请选择') {
                        this.$Toast('请先选择投诉分类');
                    } else {
                        this.isshowBox2 = true;
                    }
                    break;
                case 2:
                    this.selectIndex = index;
                    if (this.list1[0].value === '请选择') {
                        this.$Toast('请先选择投诉分类');
                    } else if (this.list1[1].value === '请选择') {
                        this.$Toast('请先选择被投诉对象');
                    } else {
                        this.isshowBox3 = true;
                    }
                    break;
                case 3:
                    this.selectIndex = index;
                    if (this.list1[0].value === '请选择') {
                        this.$Toast('请先选择投诉分类');
                    } else if (this.list1[1].value === '请选择') {
                        this.$Toast('请先选择被投诉对象');
                    } else if (this.list1[2].value === '请选择') {
                        this.$Toast('请先选择投诉问题');
                    } else {
                        this.isshowBox4 = true;
                    }
                    break;

                default:
                    break;
                }
            },
            // 保存草稿
            saveManuscript () {
                if (this.list1[0].value === '请选择') {
                    this.$Toast('请先选择投诉分类');
                    return false;
                } else if (this.list1[1].value === '请选择') {
                    this.$Toast('请先选择被投诉对象');
                    return false;
                } else if (this.list1[2].value === '请选择') {
                    this.$Toast('请先选择投诉问题');
                    return false;
                } else if (this.list1[3].value === '请选择') {
                    this.$Toast('请先选择具体情形');
                    return false;
                // } 
                // else if (this.money && (this.money.length > 10 || !(/^\d+(\.\d+)?$/).test(String(this.money)))) {
                //     this.$Toast('请填写正确的赔偿金额');
                //     return false;
                } else if (!this.feedbackContent||this.feedbackContent.trim().length===0||this.feedbackContent.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请填写反馈结果');
                    return false;
                } else {
                    // console.log(this.feedbackContent);
                    var resultContent=this.feedbackContent.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    // console.log(resultContent.replace(/\s*/g,""))
                    if(resultContent.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的反馈内容');
                        return;
                    }
                    const data = {
                        // complainNumber: this.itemList.complainNumber,
                        mainComplainNumber: this.itemList.mainComplainNumber,
                        subId: this.itemList.subId,
                        feedbackContent: this.feedbackContent.replace(/\s*/g,""),
                        // resultType: this.resultType,
                        // money: this.money.trim(),
                        images: this.imgUrl
                   }
                    api.worker.saveFeedBack(data).then((res) => {
                        console.log(res);
                        if (res.ret === 0) {
                            this.$Toast('操作成功');
                            this.$router.go(-1);
                            
                        }
                    })
                }
            },
            // 提交
            submitFeedback () {
                let userInfo = this.$store.state.complaint.userInfo
                if (this.list1[0].value === '请选择') {
                    this.$Toast('请先选择投诉分类');
                    return false;
                } else if (this.list1[1].value === '请选择') {
                    this.$Toast('请先选择被投诉对象');
                    return false;
                } else if (this.list1[2].value === '请选择') {
                    this.$Toast('请先选择投诉问题');
                    return false;
                } else if (this.list1[3].value === '请选择') {
                    this.$Toast('请先选择具体情形');
                    return false;
                // }else if (this.money.length==0) {
                //    if (this.money && (  !(/^\d+(\.\d+)?$/).test(String(this.money)))) {
                //     this.$Toast('请填写正确的赔偿金额')
                //     return false;
                //     // return false;
                //    }else{
                //     this.$Toast('请填赔偿金额');
                //     return false;
                //    } 
                    
                } 
                else if (!this.feedbackContent||this.feedbackContent.trim().length===0||this.feedbackContent.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请填写反馈结果');
                    return;
                }
                else {
                    var resultContent=this.feedbackContent.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    if(resultContent.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的反馈内容');
                        return;
                    }
                    const params = {
                        mainComplainNumber: this.itemList.mainComplainNumber,
                        // complainNumber: this.itemList.complainNumber,
                        subId: this.itemList.subId,
                        // subPid:this.itemList.subPid,
                        feedbackContent: this.feedbackContent.replace(/\s*/g,""),
                        complainClassify: this.classify,
                        complainObject: this.objectlist,
                        complainProblem: this.one,
                        specificSituation: this.two,
                        // resultType: this.resultType,
                        urgencyDegree: this.urgencyDegree,
                        // money: this.money,
                        complainType: this.category,
                        images: this.imgUrl
                    
                   }
                //    this.isShowBtn = true;
                    if (this.flag === false) {
                        this.flag = true;
                        api.worker.centerFeedBack(params).then((res) => {
                            console.log(res);
                            if (res.ret === 0) {
                                this.$Toast('操作成功!');
                                setTimeout(() => {
                                    this.$router.back();
                                }, 2000)
                                // this.showNav = true;
                                // this.isShowBtn = false;
                            }
                        })
                    }
                }
            },
            bandleBtn (type) {
                if (type === 1) {
                    this.$router.push({
                        path: '/complaint/detailList/complaintSheet',
                        query: {
                            type: 'queryListItem'
                        }
                    })
                    // this.$router.back();
                } else if (type === 2) {
                    this.$router.push({
                        path: '/complaint/resultDetail',
                        query: {
                            mainComplainNumber: this.itemList.mainComplainNumber
                        }
                    });
                }
            },
            getIntelligentClassify() {
                let params = {
                  mainComplainNumber: this.itemList.mainComplainNumber,
                }
                api.worker.getIntelligentClassify(params).then((res) => {
                    if (res.ret === 0) {
                      let obj = {'name':res.data.label,'id':res.data.value};
                      let obj1 = {'name':res.data.child.label,'id':res.data.child.value};
                      console.log('obj', obj);
                      console.log('obj1', obj1);


                      if (obj.name && obj.id) {
                        this.classify = obj.id;
                        this.getType1(obj.id);
                        this.list1[0].value = obj.name;
                      } else {
                        this.$Toast('请选择正确的分类');
                      }

                      if (obj1.name && obj1.id) {
                        this.objectlist = obj1.id;
                        this.getType2(obj1.id);
                        this.list1[1].value = obj1.name;
                      } else {
                        this.$Toast('请选择正确的分类');
                      }

                      
                    }
                })
            },
            // 获取投诉详情
            getSaveDetail () {
                const data = {
                    mainComplainNumber: this.itemList.mainComplainNumber,
                    subId: this.itemList.subId
                }
                api.worker.getFreeBack(data).then((res) => {
                    if (res.data && res.data.saveDetails) {
                        // this.money = parseInt(res.data.saveDetails.money) || '';
                        this.feedbackContent = res.data.saveDetails.feedbackContent;
                        // this.resultType= res.data.saveDetails.resultType||3;
                        // this.tabNum2=parseInt(res.data.saveDetails.resultType)-3||0;
                        this.imgUrl = res.data.saveDetails.images;
                    }
                })
            }

        }
    }
</script>

<style lang="less" scoped>
.feedback {
    background: #fbfbfb;
    .feedback_list {
        .ul_view {
            list-style: none;
            display: flex;
            li {
                margin-right: 10px;
                width: 100%;
            }
            .tab {
                height: 30px;
                width: 100%;
                text-align: center;
                line-height: 30px;
                font-size:14px;
                font-weight:400;
                color:#000000;
                background:rgba(255,255,255,1);

            }
            .tabColor {
                height: 30px;
                width: 100%;
                text-align: center;
                line-height: 30px;
                font-size:14px;
                font-weight:400;
                color: rgba(255,255,255,1);
                background:#36b374;
            }
            .tabColor_orange {
                height: 30px;
                width: 100%;
                text-align: center;
                line-height: 30px;
                font-size:14px;
                font-weight:400;
                color: rgba(255,255,255,1);
                background:#E6611E;
            }
            .tabColor_red {
                height: 30px;
                width: 100%;
                text-align: center;
                line-height: 30px;
                font-size:14px;
                font-weight:400;
                color: rgba(255,255,255,1);
                background:red;
            }
        }
        .sell_price{
            width:100%;
            padding:0px 16px;
            background-color: #fff;
            
            .sell_item{
                display: flex;
                flex-direction: row;
                align-items: center;
                padding:16px 0;
                box-sizing: border-box;
                justify-content: space-between;
                .sell_text{
                    font-size:14px;
                }
                .sell_right{
                    input{
                        font-size:14px;
                    }
                }
                
            }
        }
        .money{
            text-align: right;
            color: initial;
        }
        .text_acitve{
            color: initial!important;
        }
        .list_price .van-cell__value {
            display: flex;
        }
        .list_text {
            flex-direction: column;
        }
        .list_text  {
            text-align: left;
        }
        .list_text1 {
            flex-direction: column;
        }
        .list_text1 .van-cell__value  {
            text-align: left;
        }
        .list_text1 .van-cell__value .van-uploader  {
            position: static;
        }
        .van-cell__value {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .guide_buttom {
            width: 100%;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-top: 10px;
            .guide_btn {
                background: #36b374;
                color: #fff;
                font-size: 14px;
                height: 40px;
                width: 93%;
                border-radius: 5px;
                text-align: center;
                line-height: 40px;
            }
            .guide_save_btn {
                margin: 10px 0;
                background: #F0F0F0;
                color: #909090;
                font-size: 14px;
                height: 40px;
                width: 93%;
                border-radius: 5px;
                text-align: center;
                line-height: 40px;
            }
        }
        .uploadBox{
            padding: 20px;
        }
    }

    .window_box {
        width: 260px;
        // height: 200px;
        border-radius: 3px;
        padding: 24px;
        text-align: center;
        .window_title {
            font-size: 18px;
            font-weight: 500;
            color: #333;
            margin-bottom: 16px;
        }
        .window_nav {
            font-size: 14px;
            font-weight: 400;
            color: #333;
        }
        .window_btn {
            margin-top: 20px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .window_btn_item {
                border-radius: 3px;
                width: 76px;
                height: 38px;
                background: #36b374;
                line-height: 38px;
                color: #fff;
            }
        }
    }
}
</style>
